/* ATN Membership - Section 08: Real Members testimonial slider */
/* Arrows-only scroller with native touch swipe. Re-inits on section load. */
(function () {
  function AtnMemTst(root) {
    if (!root || root.dataset.tstInit === '1') return;
    root.dataset.tstInit = '1';

    var viewport = root.querySelector('[data-tst-viewport]');
    var prev = root.querySelector('[data-tst-prev]');
    var next = root.querySelector('[data-tst-next]');
    if (!viewport) return;

    function gap() {
      var g = parseInt(getComputedStyle(viewport).columnGap, 10);
      return isNaN(g) ? 0 : g;
    }

    function step() {
      var card = viewport.querySelector('.atn-mem-tst-card');
      if (!card) return Math.round(viewport.clientWidth * 0.85);
      return Math.round(card.getBoundingClientRect().width + gap());
    }

    function update() {
      var max = viewport.scrollWidth - viewport.clientWidth - 1;
      var x = viewport.scrollLeft;
      if (prev) prev.toggleAttribute('disabled', x <= 0);
      if (next) next.toggleAttribute('disabled', x >= max);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-atn-mem-tst]').forEach(AtnMemTst);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-atn-mem-tst]');
    if (el) AtnMemTst(el);
  });
})();